<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen tarjeta Jurado:</h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!jury_background_card"
              v-model="jury_background_card"
              :rules="rules"
              @change="onJuriesBackgroundChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen tarjeta Jurados"
              :messages="['Para una mejor visualización, usar una imagen de 220x140 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="jury_background_card"
              width="220px">
              <v-img
                :src="url_jury_background_card"
                height="140px"
                width="220px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteJuriesBackrgound()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen tarjeta Evaluadores:</h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!evaluator_background_card"
              v-model="evaluator_background_card"
              :rules="rules"
              @change="onEvaluatorsBackgroundChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen tarjeta Evaluadores"
              :messages="['Para una mejor visualización, usar una imagen de 220x140 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="evaluator_background_card"
              width="220px">
              <v-img
                :src="url_evaluator_background_card"
                height="140px"
                width="220px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteEvaluatorsBackrgound()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationJuriesCard',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      
      customization:[],

      jury_background_card: null,
      url_jury_background_card: null,

      evaluator_background_card: null,
      url_evaluator_background_card: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization

          this.jury_background_card = response.data.data.customization.jury_background_card
          this.url_jury_background_card = APP_URL+ this.jury_background_card

          this.evaluator_background_card = response.data.data.customization.evaluator_background_card
          this.url_evaluator_background_card = APP_URL+ this.evaluator_background_card

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('jury_background_card', this.jury_background_card)
        formData.append('evaluator_background_card', this.evaluator_background_card)
        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-juries-evaluators',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      onJuriesBackgroundChange() {
        this.url_jury_background_card = URL.createObjectURL(this.jury_background_card);
      },

      deleteJuriesBackrgound(){
        this.jury_background_card=null
        this.url_jury_background_card=null
      },

      onEvaluatorsBackgroundChange() {
        this.url_evaluator_background_card = URL.createObjectURL(this.evaluator_background_card);
      },

      deleteEvaluatorsBackrgound(){
        this.evaluator_background_card=null
        this.url_evaluator_background_card=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
